
export const suspendColumnsDefinition = [
  {
    headerName: 'PhoneNumber',
    dataType: 'number',
    length: 10,
  },
  {
    headerName: 'Suspend_reason',
    dataType: 'range',
    // tslint:disable-next-line:max-line-length
    range: ['Lost/Stolen Suspend', 'Seasonal Suspend', 'Temporary Suspend', 'Reseller Suspend without charges', 'Reseller Suspend with charges',
   'Implementation Suspend','MCSA Contractual Suspend','Special Unlimited Suspend', 'Lost/Stolen_Suspend', 'Seasonal_Suspend', 'Temporary_Suspend',
   'Reseller_Suspend_without_charges', 'Reseller_Suspend_with_charges', 'Implementation_Suspend','MCSA_Contractual_Suspend','Special_Unlimited_Suspend', 'Retention_Suspend_(Gov_Only)', 'Retention Suspend (Gov Only)'],
  },
  {
    headerName: 'Suspend_ApproverType(not required for Lost/Stolen or Seasonal suspend)',
    dataType: 'tempsuspendrange',
    range: ['SENIOR MANAGER',  'DIRECTOR', 'VP'],
  },
  {
    headerName: 'Suspend_ApproverType(not required for Lost/Stolen or Seasonal suspend)',
    dataType: 'string',
    value: '',
  },
  {
    headerName: 'Suspend_ApproverType(not required for Lost/Stolen or Seasonal suspend)',
    dataType: 'resellerrange',
    range: ['SALES REP INITIATED', 'B2B MARKETING MANAGER', 'SALES DIRECTOR', 'VP', 'CUSTOMER INITIATED'],
  },
  {
    headerName: 'Suspend_start_date',
    dataType: 'date',
    minDate: new Date().toDateString(),
  },
  {
    headerName: 'Suspend_start_date_today',
    dataType: 'dateToday',
    minDate: new Date().toDateString(),
  },
  {
    headerName: 'Suspend_end_date',
    dataType: 'date',
    minDate: new Date().toDateString(),
  },
];

export const restoreColumnsDefinition = [
  {
    headerName: 'PhoneNumber',
    dataType: 'number',
    length: 10,
  },
  {
    headerName: 'RestoreDate',
    dataType: 'date',
    minDate: new Date(),
  },
];
export const transferColumnsDefinition = [
  {
    headerName: 'T-Mobile MSISDN',
    dataType: 'number',
    length: 10,
  },
  {
    headerName: 'Number to transfer',
    dataType: 'number',
    length: 10,
  },
  {
    headerName: 'Carrier account number',
    dataType: 'date',
    length: 30,
  },
  {
    headerName: 'Port Date (MM/DD/YYYY)',
    dataType: 'date',
    minDate: new Date(),
  },
  {
    headerName: 'Port Start Time (PST) (HR:MIN:SS AM/PM) (optional)',
    dataType: 'date',
    minTime: new Date(),
  },
];

export const simSwapColumnsDefinition = [
  {
    headerName: 'PhoneNumber',
    dataType: 'number',
    length: 10,
  },
  {
    headerName: 'OldSim',
    dataType: 'number',
    length: 20,
  },
  {
    headerName: 'NewSim',
    dataType: 'number',
    length: 20,
  },
  {
    headerName: 'Reason_For_Change',
    dataType: 'range',
    // tslint:disable-next-line:max-line-length
    range: ['Customer SIM/SIM in Kit', 'Customer/Employee Request', 'Validated Defective SIM', 'Lost/Stolen/Damaged SIM'],
  },

];
export const eSimSwapColumnsDefinition = [
  {
    headerName: 'PhoneNumber',
    dataType: 'number',
    length: 10,
  },
  {
    headerName: 'OldSim',
    dataType: 'number',
    length: 20,
  },
  {
    headerName: 'EID (for eSIM)',
    dataType: 'text',
    length: 32,
  },
  {
    headerName: 'NewSIM (for Physical SIM)',
    dataType: 'number',
    length: 20,
  },
  {
    headerName: 'Reason_For_Change',
    dataType: 'range',
    // tslint:disable-next-line:max-line-length
    range: ['Customer SIM/SIM in Kit', 'Customer/Employee Request', 'Validated Defective SIM', 'Lost/Stolen/Damaged SIM'],
  },

];
export const simChangeReason = [
  {
    code: 'BYOS',
    description: 'Customer SIM/SIM in Kit',
  },
  {
    code: 'CR',
    description: 'Customer/Employee Request',
  },
  {
    code: 'DFS',
    description: 'Validated Defective SIM',
  },
  {
    code: 'LS',
    description: 'Lost/Stolen/Damaged SIM',
  },
];

export const changeNumbersColumnsDefinition = [
  {
    headerName: 'PhoneNumber',
    dataType: 'number',
    length: 10,
  },
  {
    headerName: 'Preferred_Area_Code',
    dataType: 'number',
    length: 3,
  },
  {
    headerName: 'Reason_For_Change',
    dataType: 'range',
    // tslint:disable-next-line:max-line-length
    range: ['Customer/Employee moved', 'Customer/Employee request', 'VHarassing phone calls', 'Incorrect area code/prefix', 'New user'],
  },

];


export const cancelSubscriberColumnsDefinition = [
  {
    headerName: 'PhoneNumber',
    dataType: 'number',
    length: 10,
  },
  {
    headerName: 'Cancel_reason',
    dataType: 'range',
    range: [
      'Billing problems',
      'Coverage Issues',
      'Lost or Stolen equipment',
      'Low Usage',
      'No Longer an Employee'
    ],
  },
  {
    headerName: 'Cancel_date',
    dataType: 'date',
    minDate: new Date().toDateString()
  },
];

export const TPOPColumnsDefinition = [
  {
    headerName: 'AccountNumber',
    dataType: 'ban',
    length: 9,
  },
  {
    headerName: 'PhoneNumber',
    dataType: 'number',
    length: 10,
  },
];

export const changeServiceColumnsDefinition = [
  {
    headerName: 'PhoneNumber',
    dataType: 'number',
    length: 10,
  },
  {
    headerName: 'ServiceAction',
    dataType: 'range',
    range: [
      'Add',
      'Remove',
      ''
    ],
  },
];


export const managePairingColumnsDefinition = [
  {
    headerName: 'Voice_Line',
    dataType: 'number',
    length: 10,
  },
  {
    headerName: 'Watch_Line',
    dataType: 'number',
    length: 10,
  },
  {
    headerName: 'Action',
    dataType: 'range',
    range: [
      'PAIR',
      'UNPAIR'
    ],
  },
];
